<script>
	import { _ } from 'svelte-i18n';
    import Button from './Button.svelte';

    export let scrollToId = (id) => {}

</script>

<style>
    .welcome {
        background-color: var(--colorBgVariant);
        padding: var(--spacingXXXLarge) var(--spacingXXLarge);
    }

    .welcome-info {
        margin: var(--spacingXLarge) auto var(--spacingXLarge);
        max-width: 800px;
    }

    .button-row {
        margin: var(--spacingXLarge) auto;
        max-width: 500px;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
    }
</style>

<div class="welcome">
    <h1>{$_('welcome.title')}</h1>
    <div class='welcome-info'>
        <p>{@html $_('welcome.welcome')}</p>
    </div>
    <div class="button-row">
        <Button width=230px on:click={scrollToId('calculate')}>{$_('welcome.button_calculate')}</Button>
        <Button width=230px on:click={scrollToId('learn')}>{$_('welcome.button_learn')}</Button>
    </div>
</div>